import { API } from "aws-amplify";
import { constructStatusQueryString } from "utils/actions";

const BASE_URL = "/vpp_user_registration";

export const GET_VPP_REGISTRATION_LIST_REQUEST =
  "@@vppUserRegistration/GET_VPP_REGISTRATION_LIST_REQUEST";
export const GET_VPP_REGISTRATION_LIST_SUCCESS =
  "@@vppUserRegistration/GET_VPP_REGISTRATION_LIST_SUCCESS";
export const GET_VPP_REGISTRATION_LIST_FAILURE =
  "@@vppUserRegistration/GET_VPP_REGISTRATION_LIST_FAILURE";

export function getVppUserRegistrationList(formData = {}) {
  return async (dispatch) => {
    dispatch({
      type: GET_VPP_REGISTRATION_LIST_REQUEST,
    });
    try {
      let url = BASE_URL;
      if (formData) {
        url = constructStatusQueryString(url, formData);
      }
      const response = await API.get("cmsAPI", url);
      dispatch({
        type: GET_VPP_REGISTRATION_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_VPP_REGISTRATION_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_VPP_REGISTRATION_DETAILS_REQUEST =
  "@@vppUserRegistration/GET_VPP_REGISTRATION_DETAILS_REQUEST";
export const GET_VPP_REGISTRATION_DETAILS_SUCCESS =
  "@@vppUserRegistration/GET_VPP_REGISTRATION_DETAILS_SUCCESS";
export const GET_VPP_REGISTRATION_DETAILS_FAILURE =
  "@@vppUserRegistration/GET_VPP_REGISTRATION_DETAILS_FAILURE";

export function getVppUserRegistration(id) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_VPP_REGISTRATION_DETAILS_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `${BASE_URL}/${id}`);
      dispatch({
        type: GET_VPP_REGISTRATION_DETAILS_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_VPP_REGISTRATION_DETAILS_FAILURE,
        payload: error,
      });
    }
  };
}

export const POST_VPP_REGISTRATION_CREATE_REQUEST =
  "@@vppUserRegistration/POST_VPP_REGISTRATION_CREATE_REQUEST";
export const POST_VPP_REGISTRATION_CREATE_SUCCESS =
  "@@vppUserRegistration/POST_VPP_REGISTRATION_CREATE_SUCCESS";
export const POST_VPP_REGISTRATION_CREATE_FAILURE =
  "@@vppUserRegistration/POST_VPP_REGISTRATION_CREATE_FAILURE";

export function createVppUserRegistration(value, callback) {
  return async (dispatch) => {
    dispatch({
      type: POST_VPP_REGISTRATION_CREATE_REQUEST,
    });
    try {
      const init = {
        body: value,
      };
      const response = await API.post("cmsAPI", BASE_URL, init);
      dispatch({
        type: POST_VPP_REGISTRATION_CREATE_SUCCESS,
        payload: response,
      });
      dispatch(getVppUserRegistrationList());
      if (callback) {
        callback(true);
      }
    } catch (error) {
      dispatch({
        type: POST_VPP_REGISTRATION_CREATE_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(false);
      }
    }
  };
}

export const VPP_REGISTRATION_UPDATE_REQUEST =
  "@@vppUserRegistration/VPP_REGISTRATION_UPDATE_REQUEST";
export const VPP_REGISTRATION_UPDATE_SUCCESS =
  "@@vppUserRegistration/VPP_REGISTRATION_UPDATE_SUCCESS";
export const VPP_REGISTRATION_UPDATE_FAILURE =
  "@@vppUserRegistration/VPP_REGISTRATION_UPDATE_FAILURE";

export function updateVppUserRegistration(ownerId, id, value, callback) {
  return async (dispatch) => {
    dispatch({
      type: VPP_REGISTRATION_UPDATE_REQUEST,
    });
    try {
      const init = {
        body: value,
      };
      const response = await API.put(
        "cmsAPI",
        `${BASE_URL}/${ownerId}/${id}`,
        init,
      );
      dispatch({
        type: VPP_REGISTRATION_UPDATE_SUCCESS,
        payload: response,
      });
      dispatch(getVppUserRegistrationList());
      if (callback) {
        callback(true);
      }
    } catch (error) {
      dispatch({
        type: VPP_REGISTRATION_UPDATE_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(false);
      }
    }
  };
}

export const VPP_REGISTRATION_DELETE_REQUEST =
  "@@vppUserRegistration/VPP_REGISTRATION_DELETE_REQUEST";
export const VPP_REGISTRATION_DELETE_SUCCESS =
  "@@vppUserRegistration/VPP_REGISTRATION_DELETE_SUCCESS";
export const VPP_REGISTRATION_DELETE_FAILURE =
  "@@vppUserRegistration/VPP_REGISTRATION_DELETE_FAILURE";

export function deleteVppUserRegistration(id, callback) {
  return async (dispatch) => {
    dispatch({
      type: VPP_REGISTRATION_DELETE_REQUEST,
    });
    try {
      const response = await API.del("cmsAPI", `${BASE_URL}/${id}`);
      dispatch({
        type: VPP_REGISTRATION_DELETE_SUCCESS,
        payload: response,
      });
      dispatch(getVppUserRegistrationList());
      if (callback) {
        callback(true);
      }
    } catch (error) {
      dispatch({
        type: VPP_REGISTRATION_DELETE_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(false);
      }
    }
  };
}

export const GET_LOCATION_SEARCH_REQUEST =
  "@@vppUserRegistration/GET_LOCATION_SEARCH_REQUEST";
export const GET_LOCATION_SEARCH_SUCCESS =
  "@@vppUserRegistration/GET_LOCATION_SEARCH_SUCCESS";
export const GET_LOCATION_SEARCH_FAILURE =
  "@@vppUserRegistration/GET_LOCATION_SEARCH_FAILURE";

export function searchLocation(search) {
  return async (dispatch) => {
    dispatch({
      type: GET_LOCATION_SEARCH_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/location_search?search=${encodeURIComponent(search)}`,
      );
      dispatch({
        type: GET_LOCATION_SEARCH_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_LOCATION_SEARCH_FAILURE,
        payload: error,
      });
    }
  };
}
